import React from 'react'
import TrainingRequestFormPart from '../../react4xp/components/FormPages/TrainingRequestForm'
import { country_list } from '/lib/modules/util/constants'

function TrainingRequestForm({ breadcrumbs, title, intro, emailServiceUrl, productsCategoriesObj, privacyPolicyCheckboxRichText, recaptchaSiteKey, recaptchaValidationUrl, validationSummary}) {
	return (
		<TrainingRequestFormPart
			siteKey={recaptchaSiteKey}
			validationRecaptchaUrl={recaptchaValidationUrl}
			topInfos={{
				title: title,
				intro: intro
			}}
			form={{
				endpoint: emailServiceUrl,
				onSuccess: () => console.log('Sending email...'),
				onError: () => console.error('Error sending email')
			}}
			steps={{
				step1: {
					title: 'Choose the product(s) you need training for',
					options: productsCategoriesObj,
					errorMessage: 'Please choose one request type.'
				},
				step2: {
					title: 'Choose your preferred training option (Not applicable for the Skipper-portfolio)',
					options: [
						{
							value: 'At your location'
						},
						{
							value: 'At Jotron'
						},
						{
							value: 'Remote / online'
						}
					],
					errorMessages: {
						required: 'Please choose one location.'
					}
				},
				step3: {
					title: 'Fill in your details',
					inputs: [
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'first-name',
								name: 'First name',
								label: 'First name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'last-name',
								name: 'Last name',
								label: 'Last name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'title-position',
								name: 'Title / Position',
								label: 'Title / Position',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'company-name',
								name: 'Company name',
								label: 'Company name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'select',
							select: {
								id: 'country',
								name: 'Country',
								label: 'Country',
								defaultValue: 'Choose country',
								options: country_list,
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							},
						},
						{
							type: 'input',
							input: {
								type: 'email',
								id: 'email',
								name: 'Email',
								label: 'Email',
								required: true,
								errorMessages: {
									required: 'This field is required.',
									invalidEmail: 'Invalid email format.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'tel',
								id: 'phone-number',
								name: 'Phone number',
								label: 'Phone number',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'textarea',
							textarea: {
								id: 'message',
								name: 'Message',
								label: 'Message',
								placeholder: 'Write your comment here...',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						}
					]
				}
			}}
			privacyCheckbox={{
				name: 'terms',
				required: true,
				errorMessages: {
					required: 'This field is required.'
				},
				text: privacyPolicyCheckboxRichText
			}}
			submit={{
				validationMessage: validationSummary,
				label: 'Submit',
				successMessage: 'Your message has been submitted successfully.'
			}}
		/>
	)
}

export default TrainingRequestForm